// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleSwitch_root__KTLuP","switch":"ToggleSwitch_switch__YVRoY","slider":"ToggleSwitch_slider__E_IWJ","round":"ToggleSwitch_round__28vyL"};